import React from 'react';
import { motion } from 'framer-motion';

const ProgressBar = ({ progress, currentStep, totalSteps }) => {
  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-medium text-slate-700">
          Step {currentStep} of {totalSteps}
        </span>
        <span className="text-sm text-slate-600">{Math.round(progress)}% Complete</span>
      </div>
      
      <div className="w-full bg-slate-200 rounded-full h-2 overflow-hidden">
        <motion.div
          className="progress-bar h-full rounded-full"
          initial={{ width: 0 }}
          animate={{ width: `${progress}%` }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;